import { IColors } from './types';

export const colors: IColors = {
  danger: {
    100: '#E84C3D',
    80: 'rgba(232, 76, 61, 0.8)',
    60: 'rgba(232, 76, 61, 0.6)',
    40: 'rgba(232, 76, 61, 0.4)',
    20: 'rgba(232, 76, 61, 0.2)',
    10: 'rgba(232, 76, 61, 0.1)',
    5: 'rgba(232, 76, 61, 0.05)',
    non_alpha: '#FEF6F5',
  },
  success: {
    100: '#1EA35F',
    80: 'rgba(30, 163, 95, 0.8)',
    60: 'rgba(30, 163, 95, 0.6)',
    40: 'rgba(30, 163, 95, 0.4)',
    20: 'rgba(30, 163, 95, 0.2)',
    10: 'rgba(30, 163, 95, 0.1)',
    5: 'rgba(30, 163, 95, 0.05)',
  },
  info: {
    100: '#B6E0EC',
    80: 'rgba(182, 224, 236, 0.8)',
    60: 'rgba(182, 224, 236, 0.6)',
    40: 'rgba(182, 224, 236, 0.4)',
    20: 'rgba(182, 224, 236, 0.2)',
    10: 'rgba(182, 224, 236, 0.1)',
    5: 'rgba(182, 224, 236, 0.05)',
  },
  black: {
    100: '#272A32',
    80: 'rgba(39, 42, 50, 0.8)',
    60: 'rgba(39, 42, 50, 0.6)',
    40: 'rgba(39, 42, 50, 0.4)',
    20: 'rgba(39, 42, 50, 0.2)',
    10: 'rgba(39, 42, 50, 0.1)',
    5: 'rgba(39, 42, 50, 0.05)',
  },
  white: {
    100: '#FFFFFF',
    80: 'rgba(255, 255, 255, 0.8)',
    60: 'rgba(255, 255, 255, 0.6)',
    40: 'rgba(255, 255, 255, 0.4)',
    20: 'rgba(255, 255, 255, 0.2)',
    10: 'rgba(255, 255, 255, 0.1)',
    5: 'rgba(255, 255, 255, 0.05)',
  },
  neutral: {
    100: '#272A32',
    80: '#4E5461',
    60: '#9297A2',
    40: '#D0D3D9',
    20: '#EEEFF2',
    10: '#F6F7F9',
    5: '#FCFDFF',
  },
};

const BASE_SPACING = 4;

export const spacing = {
  1: `${1 * BASE_SPACING}px`,
  2: `${2 * BASE_SPACING}px`,
  3: `${3 * BASE_SPACING}px`,
  4: `${4 * BASE_SPACING}px`,
  6: `${6 * BASE_SPACING}px`,
  8: `${8 * BASE_SPACING}px`,
  12: `${12 * BASE_SPACING}px`,
  16: `${16 * BASE_SPACING}px`,
  20: `${20 * BASE_SPACING}px`,
  24: `${24 * BASE_SPACING}px`,
};
